import { newRelicConfig } from "../config/newrelicConfig";

export const loadNewRelicScript = (): void => {
	// Attach New Relic configuration before loading the script
	(window as any).NREUM = newRelicConfig;

	// Create and configure the New Relic script element securely
	const script = document.createElement("script");
	script.src = "https://js-agent.newrelic.com/nr-loader-spa-1.290.0.min.js";
	script.integrity = "sha384-T8Do6cKO0i2kiW/+fhjHLdHg9NwSqvKpIHfHHfXDOm6FzTBOjqj1idQvjZfDmpny";
	script.crossOrigin = "anonymous";
	script.async = true;

	script.onload = () => {
	};

	// Append script to document head
	document.head.appendChild(script);
};
